import React from 'react'
import ReactDOM from 'react-dom'
import './styles/index.scss'
import App from './App'
import { BrowserRouter as Router } from 'react-router-dom'
import ReactGA from 'react-ga'

ReactGA.initialize('UA-218250800-1')

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
)
